import script from "./step-content.vue?vue&type=script&setup=true&lang=js"
export * from "./step-content.vue?vue&type=script&setup=true&lang=js"

import "./step-content.vue?vue&type=style&index=0&id=4abd7ff1&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4abd7ff1"]])

export default __exports__